import type {
  FilterKindEnum,
  SingleFilterState,
  UpsellType,
} from '../../../domains/global-filters/model/FilterChain';
import { StyledMenuButton } from './StyledMenuButton';

interface GenericMenuButtonProps {
  filterState: SingleFilterState;
  onNewFilter: (kind: FilterKindEnum) => void;
  isMaxReached: boolean;
  onUpsellClicked?: (upsellType: UpsellType) => void;
}

export const GenericMenuButton = ({
  filterState,
  onNewFilter,
  isMaxReached,
  onUpsellClicked,
}: GenericMenuButtonProps): JSX.Element | null => {
  return (
    <StyledMenuButton
      key={filterState.kind}
      icon={filterState.config.isLocked === true ? 'lock' : filterState.metaData.iconName}
      kind="ghost"
      size="s"
      onClick={() =>
        filterState.config.isLocked === true
          ? onUpsellClicked?.(filterState.kind)
          : onNewFilter(filterState.kind)
      }
      isLocked={filterState.config.isLocked === true}
      isDisabled={isMaxReached}
      aria-label={`Add ${filterState.metaData.filterName}`}
    >
      {filterState.metaData.filterName}
    </StyledMenuButton>
  );
};
